import React from 'react';
import { Loader } from '@saviynt/design-system';

import './UserSkeleton.css';

const SKELETON_COUNT = 2;

function UserSkeleton() {
  return (
    <div className='Ext-UserSkeleton' role='status' aria-label='Loading users'>
      <Loader
        kind='skeleton'
        format='circle'
        color='inverse'
        className='Ext-UserSkeleton-avatar'
      />
      <div className='Ext-UserSkeleton-userDetails'>
        {Array.from({ length: SKELETON_COUNT }).map(() => (
          <div className='Ext-UserSkeleton-userDetails-text'> </div>
        ))}
      </div>
    </div>
  );
}

export default UserSkeleton;
